import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class GallerySlider {
    constructor($el) {
        this.$el = $el;
        this.slider = this.$el.querySelector('[data-gallery-slider]')
        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        new Swiper(this.slider, {
            spaceBetween: 24,
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchOverflow: true,
            centeredSlides: true,
            navigation: {
                nextEl: this.$el ? this.$el.querySelector('[data-gallery-arrow-next]') : null,
                prevEl: this.$el ? this.$el.querySelector('[data-gallery-arrow-prev]') : null,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    centeredSlides: false,
                    slidesPerView: 4.2,
                },
                1200: {
                    slidesPerView: 5.2,
                    centeredSlides: false,
                },
            },
        });
    }
}
